module.exports = __webpack_public_path__ + "static/act-e7e0fee0ca1b6d68eb07d22586eefc9c.png";